const delegateListener = (event, selector, callback) =>
    document.addEventListener(event, e =>
        e.target.closest(selector) ? callback(e) : null);

export {delegateListener};